import { createActionConstants } from './actionsHelper';

export const ReportingActionTypes = {
  REPORTING_APP_FILTER: 'REPORTING_APP_FILTER',
  ...createActionConstants('FETCH_REPORTS')
};

export function reportingAppFilter(appName) {
  return {
    type: ReportingActionTypes.REPORTING_APP_FILTER,
    payload: {
      appName
    }
  };
}

export function fetchReports(
  startDate = null,
  endDate = null,
  appName = '',
  shouldAppsFetching = false
) {
  return {
    type: ReportingActionTypes.FETCH_REPORTS_REQUESTED,
    payload: {
      startDate,
      endDate,
      appName,
      shouldAppsFetching
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/reportingActions.js